<div class="custom-snackbar">
  <span>{{ data.message }}</span>
  <button mat-button (click)="closeSnackbar()"><mat-icon>close</mat-icon></button>
</div>